import React, { useState } from "react";

import { Icon } from "@iconify/react";
import { Button, Col, Row, Space } from "antd";
import Text from "antd/es/typography/Text";
import Title from "antd/es/typography/Title";
import { toast } from "utils/toast";

import { useUpdateLandlord } from "hooks/useLandlords";

import LandlordListModal from "js/components/Landlords/LandlordListSelect/LandlordListModal";
import { ModernLandlordModal } from "js/components/Landlords/ModernLandlordModal";
import { LandlordDetailsSectionProps } from "js/components/Properties/types";
import { Landlord } from "js/components/types";

import { toTitleCase } from "../../../../../utils/utils";

const LandlordDetailsSection: React.FC<LandlordDetailsSectionProps> = ({
  landlordData = {},
  setLandlordData,
  readOnly = false,
}) => {
  const [isLandlordModalOpen, setIsLandlordModalOpen] = useState(false);
  const [isLandlordModalAsignOpen, setIsLandlordModalAsignOpen] =
    useState(false);

  const updateLandlordMutation = useUpdateLandlord({
    onSuccess: (data) => {
      toast.success("Datos actualizados");
      setLandlordData(data);
      setIsLandlordModalOpen(false);
    },
    onError: () => {
      toast.error("Ha ocurrido un error.");
    },
  });

  const handleSave = async (updatedLandlord: Partial<Landlord>) => {
    const landlordId =
      "id" in landlordData ? (landlordData as Landlord).id : undefined;
    if (!landlordId) {
      toast.error("ID de propietario no encontrado.");
      return;
    }
    const payload: Landlord = {
      ...(landlordData as Landlord),
      ...updatedLandlord,
    };
    return updateLandlordMutation.mutateAsync({
      landlord: payload,
      landlordId,
    });
  };

  return (
    <>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Row align="middle" style={{ gap: 5 }}>
          <Icon
            fontSize={18}
            icon="radix-icons:person"
            style={{ marginBottom: 10 }}
          />
          <Title level={5}>Datos del Propietario</Title>
        </Row>
        {!readOnly &&
          (Object.keys(landlordData).length > 0 ? (
            <Button
              color={"geekblue"}
              variant={"filled"}
              onClick={() => setIsLandlordModalOpen(true)}
            >
              Editar
            </Button>
          ) : (
            <Button
              color={"geekblue"}
              variant={"filled"}
              onClick={() => setIsLandlordModalAsignOpen(true)}
            >
              Asignar
            </Button>
          ))}
      </Row>
      {Object.keys(landlordData).length ? (
        <Row gutter={[16, 0]}>
          <Col xs={24} md={12} style={{ marginBottom: 10 }}>
            <Space direction="vertical" size={4}>
              <Text type="secondary" style={{ height: 8 }}>
                Nombre
              </Text>
              <Text className="sentry-mask">
                {Object.keys(landlordData).length && "name" in landlordData
                  ? toTitleCase(
                      `${(landlordData as Landlord).name ?? ""} ${(landlordData as Landlord).first_surname ?? ""} ${(landlordData as Landlord).second_surname ?? ""}`,
                    )
                  : "-"}
              </Text>
            </Space>
          </Col>
          <Col xs={24} md={12}>
            <Space direction="vertical" size={4}>
              <Text type="secondary" style={{ height: 8 }}>
                Teléfono
              </Text>
              <Text className="sentry-mask">
                {"phone_number" in landlordData
                  ? ((landlordData as Landlord).phone_number ?? "-")
                  : "-"}
              </Text>
            </Space>
          </Col>
          {"legal_type" in landlordData &&
            (landlordData as Landlord).legal_type === 2 && (
              <>
                <Col xs={24} md={12} style={{ marginBottom: 10 }}>
                  <Space direction="vertical" size={4}>
                    <Text type="secondary" style={{ height: 8 }}>
                      Razón Social
                    </Text>
                    <Text className="sentry-mask">
                      {"legal_entity_name" in landlordData &&
                      (landlordData as Landlord).legal_entity_name
                        ? toTitleCase(
                            (landlordData as Landlord).legal_entity_name!,
                          )
                        : "-"}
                    </Text>
                  </Space>
                </Col>
              </>
            )}
          <Col xs={24} md={12}>
            <Space direction="vertical" size={4}>
              <Text type="secondary" style={{ height: 8 }}>
                Email
              </Text>
              <Text className="sentry-mask">
                {"email" in landlordData
                  ? ((landlordData as Landlord).email ?? "-")
                  : "-"}
              </Text>
            </Space>
          </Col>
          <Col xs={24} md={12}>
            <Space direction="vertical" size={4}>
              <Text type="secondary" style={{ height: 8 }}>
                Tipo de Persona
              </Text>
              <Text>
                {"legal_type" in landlordData
                  ? (landlordData as Landlord).legal_type === 1
                    ? "Física"
                    : (landlordData as Landlord).legal_type === 2
                      ? "Moral"
                      : "-"
                  : "-"}
              </Text>
            </Space>
          </Col>
        </Row>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
          }}
        >
          <span style={{ fontSize: 16, color: "#8c8c8c" }}>
            No hay un propietario registrado para este inmueble.
          </span>
        </div>
      )}
      {!readOnly && (
        <>
          <ModernLandlordModal
            isOpen={isLandlordModalOpen}
            onOpenChange={setIsLandlordModalOpen}
            onSave={handleSave}
            selectedLandlord={landlordData}
          />
          <LandlordListModal
            openModal={isLandlordModalAsignOpen}
            setOpenModal={setIsLandlordModalAsignOpen}
            setLandlordData={setLandlordData}
          />
        </>
      )}
    </>
  );
};

export default LandlordDetailsSection;
